/** Does not work on classes */
export const clone = (value: unknown) => {
  if (!value) {
    return value;
  }

  return JSON.parse(JSON.stringify(value));
};
